import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

import config from './config'
import App from './App.tsx'
import ScrollToTop from './ui/components/layout/ScrollToTop.tsx'

import './ui/styles/reset.css'
import './ui/styles/global.css'
import './ui/styles/customAmplify.css'

import './libraries/i18n'

posthog.init(config.VITE_POSTHOG_KEY, {
	api_host: config.VITE_POSTHOG_HOST,
	person_profiles: 'identified_only',
	capture_pageview: false,
	autocapture: {
		dom_event_allowlist: ['click'], // DOM events from this list ['click', 'change', 'submit']
		element_allowlist: ['button', 'a'], // DOM elements from this list ['a', 'button', 'form', 'input', 'select', 'textarea', 'label']
    },
})

ReactDOM.createRoot(document.getElementById('root')!).render(
	<React.StrictMode>
		<BrowserRouter>
			<ScrollToTop />
			<PostHogProvider client={posthog}>
				<App />
			</PostHogProvider>
		</BrowserRouter>
	</React.StrictMode>,
)
